<template>
  <div id="webApp" class="webApp">
    <van-nav-bar
        v-if = "!isInWZApp"
        :title = "title"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
        class="skin-danger"
    >
      <template slot="right">
        <img v-if="myUid" :src="myLogo" alt="" style="width:0.5rem; height:0.5rem; vertical-align: middle;" @click="show=true" />
          <a v-else x-click="go.login" class="cl-white">登录</a>
      </template>
    </van-nav-bar>
    <router-view class="wzPage" />
    <xs-tabbar :tabs="navTabs" :active="tabIndex" ></xs-tabbar>
    <van-action-sheet
      v-model="show"
      :actions="actions"
      @select="onSelect" 
      :round="false"
      cancel-text="取消"
    />
  </div>
</template>
<style>
.webApp {
  position: relative;
  top:0;
  left:0;
  overflow-x: hidden;
}
</style>
<script>
  import {mapState, mapGetters} from 'vuex'
  import {isInWZApp} from '../src/utils/base'
  import {WZ} from './common/globals'
  export default {
    data() {
      return {
        show: false,        
        title : '大盘猜涨跌',
        isInWZApp : isInWZApp(),
        actions : [
          {name: '切换账号', action:'login',subname: ''},
          {name: '退出', action:'logout'},
          ]
      }
    },
    computed: {
      ...mapState('config', ['navTabs']),
      ...mapGetters('nav', ['tabIndex']),
      ...mapGetters(['myUid','myLogo','myNick']),
    },
    methods: {
      onClickLeft() {
        history.back()
      },
      onSelect(item){
        this.show = false
        if(item.action === 'login') WZ.go('login')
        if(item.action === 'logout') WZ.go('logout')
      }
    },
    watch: {
      $route(to, from){
        //console.log(newVal)
        this.title = to.meta.title
      },
    },
  }
</script>
